// extracted by mini-css-extract-plugin
export default {"Products_show_container":"LoadMoreProducts_Products_show_container__va500"};